import { LogLevel } from "@azure/msal-browser";

export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(`${logLevel} - ${message}`);
}